module.exports = __webpack_public_path__ + "img/new4.999937b4.jpg";